const DEFAULT_CONFIG = {
	//接口地址
	API_URL: 'https://backstage.rsx.org.cn/api',
}

export default DEFAULT_CONFIG
